"use client";

import Script from "next/script";

export function ThemeColorSync() {
  const themeScript = () => {
    function setThemeColor() {
      const meta = document.getElementById("dynamic-theme-color");
      if (!meta) return;

      const bg = getComputedStyle(document.body).backgroundColor;
      meta.setAttribute("content", bg || "#000000");
    }

    // Initial theme color
    setThemeColor();

    // Listen for system theme changes
    const darkModeMediaQuery = matchMedia("(prefers-color-scheme: dark)");
    darkModeMediaQuery.addEventListener("change", setThemeColor);

    // Update on visibility change
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        setThemeColor();
      }
    });

    // Observe class and style changes on documentElement
    const observer = new MutationObserver(setThemeColor);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class", "style"],
    });
  };

  return (
    <Script
      dangerouslySetInnerHTML={{
        __html: `(${themeScript.toString()})();`,
      }}
      id="sync-theme-color"
      strategy="afterInteractive"
    />
  );
}
